import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import * as S from "effect/Schema";
import { PrincipalMiddleware } from "./principal.js";
import { Forbidden } from "./shares.js";
import { WorkEmailConfirmationUnavailable } from "./work-email-confirmation.js";
/**
 * One address the identity layer held for a person to decide, and who
 * claimed it. `candidates` is the conflict row's record as written — account
 * ids from either product and person ids — shown, never edited.
 */
export const HeldPair = S.Struct({
    id: S.UUID,
    normalized_email: S.String,
    classification: S.Literal("private_private", "work_private", "work_work"),
    candidates: S.Array(S.Unknown),
    detected_at: S.String,
});
/**
 * "The same person" carries the admin's confirmation that they checked with
 * the person, through the work address, that both accounts are theirs; a
 * request without it is not a decision this route accepts.
 */
export const DecideHeldPairPayload = S.Union(S.Struct({
    id: S.UUID,
    decision: S.Literal("same_person"),
    identity_checked: S.Literal(true),
}), S.Struct({
    id: S.UUID,
    decision: S.Literal("different_people"),
}));
export const DecideHeldPairResult = S.Struct({
    outcome: S.Literal("decided", "linked", "not_found", "already_decided", "unsupported"),
});
/**
 * The deliberately minimal manual-resolution surface of unified access: an
 * internal-staff-only list of held pairs with "these are the same person" /
 * "these are not". Behind the unified-access switch like the rest of it; who
 * may use it is `@pima/domain-data`'s `HeldPairs` rule.
 */
export const adminHeldPairsGroup = HttpApiGroup.make("admin-held-pairs")
    .add(HttpApiEndpoint.get("listHeldPairs", "/admin/identity/held-pairs")
    .addSuccess(S.Struct({ items: S.Array(HeldPair) }))
    .addError(Forbidden, { status: 403 })
    .addError(WorkEmailConfirmationUnavailable, { status: 404 }))
    .add(HttpApiEndpoint.post("decideHeldPair", "/admin/identity/held-pairs/decide")
    .setPayload(DecideHeldPairPayload)
    .addSuccess(DecideHeldPairResult)
    .addError(Forbidden, { status: 403 })
    .addError(WorkEmailConfirmationUnavailable, { status: 404 }))
    .middleware(PrincipalMiddleware);
//# sourceMappingURL=admin-held-pairs.js.map